import { applyStylePreservingInline } from './apply-style-preserving-inline';

const LINE_HEIGHT_THRESHOLDS = {
  SMALL: 24,
  MEDIUM: 36
} as const;

const LINE_HEIGHT_INCREASE_PERCENTAGES = {
  SMALL: 20,
  MEDIUM: 15,
  LARGE: 10
} as const;

const LETTER_SPACING_INCREASE_PERCENTAGE = 3;

function increaseByPercentage(value: number, percentage: number): number {
  return (value * (percentage + 100)) / 100;
}

function getLineHeightIncreasePercentage(lineHeight: number): number {
  if (lineHeight < LINE_HEIGHT_THRESHOLDS.SMALL) {
    return LINE_HEIGHT_INCREASE_PERCENTAGES.SMALL;
  }
  if (lineHeight < LINE_HEIGHT_THRESHOLDS.MEDIUM) {
    return LINE_HEIGHT_INCREASE_PERCENTAGES.MEDIUM;
  }
  return LINE_HEIGHT_INCREASE_PERCENTAGES.LARGE;
}

function processLineHeight(element: HTMLElement, enabled: boolean): void {
  if (!element.dataset.eappsLineHeight) {
    return;
  }

  applyStylePreservingInline({
    element,
    enabled,
    styleProperty: 'line-height',
    getValue: () => {
      const rawLineHeight = element.dataset.eappsLineHeight;
      if (!rawLineHeight) {
        return '1';
      }

      const prevLineHeight = Number(rawLineHeight);
      const increaseValue = getLineHeightIncreasePercentage(prevLineHeight);
      return `${increaseByPercentage(prevLineHeight, increaseValue)}px`;
    }
  });
}

function processLetterSpacing(element: HTMLElement, enabled: boolean): void {
  applyStylePreservingInline({
    element,
    enabled,
    styleProperty: 'letter-spacing',
    getValue: () => {
      const prevLetterSpacing = element.dataset.eappsLetterSpacing;
      if (!prevLetterSpacing) {
        return '0.05em';
      }
      return `${increaseByPercentage(Number(prevLetterSpacing), LETTER_SPACING_INCREASE_PERCENTAGE)}px`;
    }
  });
}

export function applyTextSpacing(elements: HTMLElement[], enabled: boolean) {
  elements.forEach((element) => {
    const isInvalid = !(element instanceof HTMLElement) || !element.isConnected;

    if (isInvalid) {
      return;
    }

    processLineHeight(element, enabled);
    processLetterSpacing(element, enabled);
  });
}
